import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a6c17dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "photo" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "general" }
const _hoisted_6 = { class: "general__name" }
const _hoisted_7 = { class: "general__information" }
const _hoisted_8 = { class: "item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Rođendan", -1))
const _hoisted_10 = { class: "information" }
const _hoisted_11 = { class: "item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Uloga", -1))
const _hoisted_13 = { class: "information" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppAdministratorDashboardRootUserInformationFormUpdateAvatarIndexVue = _resolveComponent("AppAdministratorDashboardRootUserInformationFormUpdateAvatarIndexVue")!
  const _component_AppAdministratorDashboardRootUserInformationFormUpdateInformationIndexVue = _resolveComponent("AppAdministratorDashboardRootUserInformationFormUpdateInformationIndexVue")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app-administrator-dashboard-root-user-information", {'is-visible': _ctx.isUserInformationVisible}])
  }, [
    _createElementVNode("a", {
      href: "#",
      class: "el-button el-button--primary el-button--small user-information-toggle",
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.setUserInformationVisibility && _ctx.setUserInformationVisibility(...args)), ["prevent"]))
    }, [
      (_ctx.isUserInformationVisible)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, "Zatvori"))
        : (_openBlock(), _createElementBlock("span", _hoisted_2, "Informacije"))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", {
        src: _ctx.getAvatar(_ctx.userInformation.content.avatar),
        alt: ""
      }, null, 8, _hoisted_4),
      _createVNode(_component_AppAdministratorDashboardRootUserInformationFormUpdateAvatarIndexVue, {
        userInformation: _ctx.userInformation,
        onGetUserInformation: _ctx.getUserInformation
      }, null, 8, ["userInformation", "onGetUserInformation"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createTextVNode(_toDisplayString(_ctx.userInformation.content.name) + " " + _toDisplayString(_ctx.userInformation.content.surname) + " ", 1),
        _createVNode(_component_AppAdministratorDashboardRootUserInformationFormUpdateInformationIndexVue, {
          userInformation: _ctx.userInformation,
          onGetUserInformation: _ctx.getUserInformation
        }, null, 8, ["userInformation", "onGetUserInformation"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.getBirthday(_ctx.userInformation.content.birthday)), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.getOrganizationMemberRole), 1)
        ])
      ])
    ])
  ], 2))
}